<template>
  <div class="pb-terms mb-0 term-selector">
    <div class="title">
      {{ $t('common.select_term') }}
    </div>
    <div class="term-container row mt-4">
      <template v-if="monthly_price">
        <detailed-select-box key="monthly" v-track="{ category: 'plan-builder', action: 'click', label: 'term-selection' }" :active="term_type === 'monthly'" :styles="{ col: 'col-md-4 col-xs-12 term-col mb-4' }" :terms="1" term_type="Month" @click.native="updateTerm(1, 'monthly')">
          <span slot="text" class="term-title-monthly">${{ monthly_price }}</span>
          <span slot="monthly-price" class="pb-2">&nbsp;</span>
        </detailed-select-box>
      </template>
      <template v-if="annual_price">
        <detailed-select-box v-for="term in item.termArray.slice(0, show_all_terms ? item.termArray[item.termArray.length - 1] : 2)" :key="term" v-track="{ category: 'plan-builder', action: 'click', label: 'term-selection' }" :active="selectedTerm === term && term_type !== 'monthly'" :styles="{ col: 'col-md-4 col-xs-12 term-col mb-4' }" :term_type="term > 1 ? 'Years' : 'Year'" :terms="term" @click.native="updateTerm(term, 'annually')">
          <span slot="savings" class="position-absolute top-m-8 start-p-25">
            <span class="d-label-padding text-nowrap text-white text-center ps-3 pe-3 border-1 radius-3 fw-bold text-sm savings-label">{{ $t('common.save') }} {{ Math.floor(getDiscount(term) * 100) }}%</span>
          </span>
          <span slot="text" class="term-title-monthly">${{ calculatePrice(term) }}</span>
          <s slot="monthly-price" class="pb-2 text-blue">${{ calculateMonthlyPrice(monthly_price, term) }}</s>
          <span slot="reccomended" class="w-100 d-block pb-2 pt-2 text-white text-center fw-semibold text-sm recommended">{{ $t('common.recommended') }}</span>
        </detailed-select-box>
      </template>
    </div>
    <div class="pb-domain-term pull-left">
      {{ $t('common.term_callout') }} -
      <a class="link-info" @click="show_all_terms = !show_all_terms" role="button">{{ show_all_terms ? $t('common.done') : $t('common.term') }}</a>
    </div>
  </div>
</template>

<script>
import DetailedSelectBox from './DetailedSelectBox.vue';
import { mapActions } from 'vuex';

export default {
  name: 'MonthlyTermSelector',

  components: {
    DetailedSelectBox
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      selectedTerm: this.item.term,
      show_all_terms: false,
      term_type: this.item.options.term_type,
      monthly_price: this.item.options.prices.monthly,
      annual_price: this.item.options.prices.annually,
      introductory_price: this.item.options.prices.introductory,
      offer_introductory: this.item.options.offer_introductory,
      introductory_terms: this.item.options.introductory_terms
    };
  },

  watch: {
    item: {
      handler(val) {
        this.selectedTerm = val.term;
      },
      deep: true
    }
  },

  methods: {
    ...mapActions('cart', ['updateProduct']),

    updateTerm(new_term, term_type) {
      this.$emit('update:loading', true);
      this.updateProduct({
        id: this.item.id,
        term: new_term,
        term_type: term_type,
        billing_plan_id: this.item.options.billing_plan_id
      })
        .then(() => {
          this.term_type = term_type;
          this.$emit('update:loading', false);
        })
        .catch(() => {
          this.$emit('update:loading', false);
        });
    },
    calculatePrice(term) {
      let price = this.annual_price;

      if (this.displayIntroductoryPrice(term)) {
        price = this.introductory_price;
      }
      const total = price * term;
      return total.toFixed(2);
    },
    calculateMonthlyPrice(price, term) {
      const total = price * 12 * term;
      return total.toFixed(2);
    },
    displayIntroductoryPrice(term) {
      return this.introductory_price && this.offer_introductory && this.introductory_terms.includes(term.toString());
    },
    getDiscount(term) {
      if (this.displayIntroductoryPrice(term)) {
        return this.getAnnualIntroductoryDiscount();
      }

      return this.getAnnualEnhancedDiscount();
    },
    getYearOfMonthlyPrice() {
      return this.monthly_price * 12;
    },
    getAnnualEnhancedDiscount() {
      const one_year_price = this.annual_price;
      return (this.getYearOfMonthlyPrice() - one_year_price) / this.getYearOfMonthlyPrice();
    },
    getAnnualIntroductoryDiscount() {
      return (this.getYearOfMonthlyPrice() - this.introductory_price) / this.getYearOfMonthlyPrice();
    }
  }
};
</script>
